export default {
  title: "OrderApp",
  errorLog: "production",
  locale: "dk",
  locales: ["dk", "en"],
  colorKeys: [
    "primary",
    "secondary",
    "third",
    "fourth",
    "five",
    "error",
    "success",
    "accent",
    "info",
    "warning",
  ],
};
